module.exports = __webpack_public_path__ + "img/02.410d54e3.png";